var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsUUID } from 'class-validator';
/**
 * Body for `POST /appointments/:id/reassign-hold-person` (PRD #1358, RS-008).
 * Confirming a website booking hold onto an existing person the practice
 * recognised: the hold is repointed to `existingUserId` and the manufactured
 * stub is archived. Advisory and staff-driven — the front desk chose this
 * person from the surfaced duplicate matches.
 */
export class ReassignHoldPersonDto {
    existingUserId;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ReassignHoldPersonDto.prototype, "existingUserId", void 0);
//# sourceMappingURL=reassign-hold-person.dto.js.map